module.exports = __webpack_public_path__ + "static/media/skin-beauty-one@2x.6b6a1706.png";